/* eslint-disable react/static-property-placement */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  cloneDeep,
  isEqual,
  isEmpty,
  forEach,
  filter,
  map,
  find,
  remove,
} from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import Modal from './Modal/Modal';
import GenericButton from './GenericButton';
import alertIcon from '../../images/alert-icon_238-51-50.png';
import clearIconBlue from '../../images/clear-field-icon_b.png';
import searchIcon from '../../images/search-icon.png';
import weightingIcon from '../../images/weighting.svg';
import {
  getStudyFromStudies,
  filterStudyList,
  getStudyFamilyIdForGivenProductNo,
  isStudyAccredited,
} from '../../util/CommonUtils';
import { saveTrackingData } from '../../util/trackerUtils';
import {
  CROSSTAB_CONSTANT,
  DV_DEFAULT_VALUE,
  QUICKREPORTS_CONSTANT,
  CLUSTER_CORRESPONDENCE_MODULE,
  UPDATE_STUDY_STORAGE_KEY,
  UPDATE_STUDY_LIST_STORAGE_KEY,
  SUPPORT_MENU_NAME,
  RLD_TOOL,
} from '../../constants';
import * as studyActions from '../../actions/studyActions';
import { MME_MODULE } from '../mme/MMEConstants';
import { GEO_MAP_MODULE } from '../geoMap/GeoMapConstant';
import { DATA_ENABLEMENT } from '../enablement/shared/DEConstants';
import authorizedIcon from '../../images/authorized.svg';
import PortalModal from './Modal/PortalModal';
import { APP_ROOT_URL } from '../../actions/urlTypes';

const modalWariningStyle = {
  width: '35%',
  height: '40px',
  left: '35%',
  top: '25%',
};

const addAfterRunCrosstabModalStyle = {
  width: '20%',
  height: 'auto',
  left: '35%',
  top: '20%',
};

const updatedStudyPopupStyle = {
  width: '574px',
  height: '40px',
  left: '35%',
  top: '25%',
};

const H6 = styled.h6`
  font-size: 14px;
  font-weight: 700;
  padding-bottom: 10px;
`;

const BtnContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;

class CommonStudySelector extends Component {
  static contextTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    router: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchText: '',
      nodes: [],
      searchNodes: [],
      checked: [],
      tempChecked: [],
      expanded: [],
      dropdownVisible: false,
      selectedStudy:
        this.props.defaultStudy !== undefined ? this.props.defaultStudy : {},
      tempSelectedStudy: '',
      data:
        this.props.studies !== undefined
          ? filterStudyList(this.props.studies, this.props.featureID)
          : [],
      weightTypeToggle: false,
      selectedWeightType: this.weightTypeCheck(props),
      weightTypeLists: this.props.defaultStudy
        ? this.props.defaultStudy.cw
        : [],
      runPopUpModalTitle: 'Crosstab',
      showStudyUpdatePopup: false,
      updatedStudyData: {},
    };
  }

  componentDidMount() {
    this.onMountMethod();
    if (this.props.commonStudySelectorRef) {
      this.props.commonStudySelectorRef(this);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.autoUpdate) {
      this.autoUpdateLatestStudy();
    }
    if (this.props.studies !== nextProps.studies) {
      this.setState(
        {
          data: filterStudyList(nextProps.studies, nextProps.featureID),
        },
        () => {
          this.categorizeStudyData();
        }
      );
    }
    if (!isEqual(nextProps.selectedWeightType, this.props.selectedWeightType)) {
      this.setState({
        selectedWeightType: this.weightTypeCheck(nextProps),
      });
    }
    if (
      nextProps.defaultStudy &&
      this.props.defaultStudy !== nextProps.defaultStudy
    ) {
      this.setState({
        selectedStudy: nextProps.defaultStudy,
        checked: [nextProps.defaultStudy.pn],
        selectedWeightType: this.weightTypeCheck(nextProps),
        weightTypeLists: nextProps.defaultStudy
          ? nextProps.defaultStudy.cw
          : [],
      });
    }
  }

  onMountMethod = () => {
    if (this.state.data !== undefined) {
      this.categorizeStudyData();
    }
    this.setState({
      checked: this.state.selectedStudy ? [this.state.selectedStudy.pn] : [],
      selectedWeightType: this.weightTypeCheck(this.props),
      weightTypeLists: this.props.defaultStudy
        ? this.props.defaultStudy.cw
        : [],
    });
    if (typeof this.props.resetMethod !== 'undefined') {
      this.props.resetMethod(() => {
        this.setState({
          selectedStudy: this.state.tempSelectedStudy,
          checked: [this.state.tempSelectedStudy.pn],
        });
      });
    }
  };

  componentWillUnmount = () => {
    if (this.props.commonStudySelectorRef) {
      this.props.commonStudySelectorRef(undefined);
    }
  };

  weightTypeCheck = props => {
    let selectedWeightType = props.selectedWeightType;
    if (selectedWeightType === undefined || isEmpty(selectedWeightType)) {
      selectedWeightType =
        props.defaultStudy && props.defaultStudy.cw
          ? props.defaultStudy.cw[0]
          : {};
    }
    return selectedWeightType;
  };

  handleOnChange = () => {
    this.setState({ searchText: this.searchBox.value }, () => {
      if (this.state.searchText.length > 1) {
        this.handleSearch();
      } else {
        this.setState({ searchNodes: [], expanded: [] });
      }
    });
  };

  handleSearch = () => {
    const mainData = cloneDeep(this.state.nodes);
    const filterData = [];
    const curExpandedList = [];
    const re = /\s\s+/g;
    const searchTextArray = this.state.searchText
      .trim()
      .replace(re, ' ')
      .toLowerCase()
      .split(' ');
    forEach(mainData, mData => {
      const mDataItem = cloneDeep(mData);
      const itemChildDta = filter(mDataItem.children, data => {
        const text = data.label.toLowerCase();
        return (
          searchTextArray.length === 0 ||
          searchTextArray.every(searchText => text.indexOf(searchText) > -1)
        );
      });
      mDataItem.children = itemChildDta;
      if (mDataItem.children.length > 0) {
        filterData.push(mDataItem);
        curExpandedList.push(mDataItem.label);
      }
    });
    this.setState({
      searchNodes: filterData.length > 0 ? filterData : undefined,
      expanded: curExpandedList,
    });
  };

  toggleDropdown = () => {
    this.setState(
      prevState => ({
        dropdownVisible: !prevState.dropdownVisible,
        expanded: [],
      }),
      () => {
        if (this.state.dropdownVisible) {
          document.addEventListener('click', this.hideDropdown, false);
        } else {
          document.removeEventListener('click', this.hideDropdown, false);
        }
      }
    );
  };

  hideDropdown = e => {
    if (this.studySelElement && this.studySelElement.contains(e.target)) {
      return;
    }
    this.toggleDropdown();
  };

  handleOnCheck = checked => {
    const curStateChecked = this.state.checked;
    this.setState(
      {
        tempChecked: [checked],
      },
      () => {
        this.toggleDropdown();
        if (curStateChecked && curStateChecked[0] !== checked) {
          if (
            typeof this.props.dataOnScreen !== 'undefined' &&
            this.props.dataOnScreen()
          ) {
            this.modalSetStudy.show();
          } else {
            this.setNewStudy();
          }
        }
      }
    );
  };

  handleOnClear = () => {
    this.setState(
      {
        searchNodes: [],
        expanded: [],
        searchText: '',
      },
      () => {
        if (this.searchBox) {
          this.searchBox.value = '';
        }
      }
    );
  };

  setNewStudy = () => {
    const localData = localStorage.getItem(UPDATE_STUDY_LIST_STORAGE_KEY)
      ? JSON.parse(localStorage.getItem(UPDATE_STUDY_LIST_STORAGE_KEY))
      : [];
    const [selectedPn] = this.state.tempChecked;
    const studyList = [];
    this.state.data.forEach(node =>
      studyList.push(
        ...node.sl.map(study => ({
          pn: study.pn,
          sd: study.sd,
          rd: study.rd,
          cw: study.cw,
          fs: study.fs,
          fe: study.fe,
          st: study.st,
          sti: study.sti,
        }))
      )
    );
    const selectedStudy = studyList.find(study => study.pn === selectedPn);
    if (
      selectedStudy.rd &&
      !localData.includes(selectedPn) &&
      this.props.menuName !== SUPPORT_MENU_NAME
    ) {
      localStorage.setItem(
        UPDATE_STUDY_STORAGE_KEY,
        JSON.stringify(selectedStudy)
      );
      this.setState({
        showStudyUpdatePopup: true,
        updatedStudyData: selectedStudy,
      });
      localData.push(selectedPn);
      localStorage.setItem(
        UPDATE_STUDY_LIST_STORAGE_KEY,
        JSON.stringify(localData)
      );
    }
    const curSelectedStudy = cloneDeep(this.state.selectedStudy);
    const lastSelectedWeightType = this.state.selectedWeightType;
    this.setState(
      {
        selectedStudy: getStudyFromStudies(
          this.state.data,
          parseInt(this.state.tempChecked[0], 0)
        ),
        tempSelectedStudy: curSelectedStudy,
        checked: this.state.tempChecked,
      },
      () => {
        const weightTypeFilterData = filter(
          this.state.selectedStudy.cw,
          item =>
            item.wt === lastSelectedWeightType.wt &&
            item.wn === lastSelectedWeightType.wn
        );
        const lastSelectedStudyFamilyId = getStudyFamilyIdForGivenProductNo(
          this.state.tempSelectedStudy.pn,
          this.props.studies
        );
        const currentSelectedStudyFamilyId = getStudyFamilyIdForGivenProductNo(
          this.state.selectedStudy.pn,
          this.props.studies
        );
        if (this.props.fromPref) {
          if (lastSelectedStudyFamilyId === currentSelectedStudyFamilyId) {
            if (weightTypeFilterData.length === 1) {
              this.props.setMethod(
                this.state.selectedStudy,
                'studyChange',
                '',
                lastSelectedWeightType
              );
            } else {
              this.props.setMethod(
                this.state.selectedStudy,
                'studyChange',
                '',
                this.state.selectedStudy.cw[0]
              );
            }
          } else {
            this.props.setMethod(
              this.state.selectedStudy,
              'studyChange',
              '',
              this.state.selectedStudy.cw[0]
            );
          }
        } else if (lastSelectedStudyFamilyId === currentSelectedStudyFamilyId) {
          if (weightTypeFilterData.length === 1) {
            this.props.setMethod(
              this.state.selectedStudy,
              lastSelectedWeightType
            );
          } else {
            this.props.setMethod(
              this.state.selectedStudy,
              this.state.selectedStudy.cw[0]
            );
          }
        } else {
          this.props.setMethod(
            this.state.selectedStudy,
            this.state.selectedStudy.cw[0]
          );
        }
      }
    );
    this.handleOnClear();
  };

  setStudyAsPreviousStudy = currentStudy => {
    const selectedProduct = [];
    selectedProduct.push(currentStudy.pn);
    this.setState({
      selectedStudy: currentStudy,
      checked: selectedProduct,
    });
  };

  categorizeStudyData = () => {
    const tempData = cloneDeep(this.state.data);
    const tempDataWCategory = [];
    function filterData(studies) {
      return map(studies, val => ({
        value: val.pn,
        label: val.sd,
        source: val.ss,
        sti: val.sti,
      }));
    }
    if (tempData !== undefined && tempData.length > 0) {
      forEach(tempData, o => {
        tempDataWCategory.push({
          value: o.sgd,
          label: o.sgd,
          children: filterData(o.sl),
        });
      });
    }
    this.setState({
      nodes: tempDataWCategory,
    });
  };

  autoUpdateLatestStudy = () => {
    const curSelectedStudy = cloneDeep(this.state.selectedStudy);
    const lastSelectedWeightType = this.state.selectedWeightType;
    let productNo = this.props.latestStudies._ct.productNo;
    if (this.props.menuName === 'QuickReports') {
      productNo = this.props.latestStudies._qr.productNo;
    } else if (this.props.menuName === 'DataHaul') {
      productNo = this.props.latestStudies._dh.productNo;
    } else if (this.props.menuName === 'Stories') {
      productNo = this.props.latestStudies._st.productNo;
    }
    this.setState(
      {
        selectedStudy: getStudyFromStudies(this.state.data, productNo),
        tempSelectedStudy: curSelectedStudy,
        checked: [productNo],
      },
      () => {
        const weightTypeFilterData = filter(
          this.state.selectedStudy.cw,
          item =>
            item.wt === lastSelectedWeightType.wt &&
            item.wn === lastSelectedWeightType.wn
        );
        const lastSelectedStudyFamilyId = getStudyFamilyIdForGivenProductNo(
          this.state.tempSelectedStudy.pn,
          this.props.studies
        );
        const currentSelectedStudyFamilyId = getStudyFamilyIdForGivenProductNo(
          this.state.selectedStudy.pn,
          this.props.studies
        );
        if (lastSelectedStudyFamilyId === currentSelectedStudyFamilyId) {
          if (weightTypeFilterData.length === 1) {
            this.props.setMethod(
              this.state.selectedStudy,
              'studyChange',
              true,
              lastSelectedWeightType
            );
          } else {
            this.props.setMethod(
              this.state.selectedStudy,
              'studyChange',
              true,
              this.state.selectedStudy.cw[0]
            );
          }
        } else {
          this.props.setMethod(
            this.state.selectedStudy,
            'studyChange',
            true,
            this.state.selectedStudy.cw[0]
          );
        }
      }
    );
    this.handleOnClear();
  };

  checkIsExpanded = category => {
    const curExpandedList = cloneDeep(this.state.expanded);
    if (curExpandedList.length > 0) {
      return find(curExpandedList, cat => cat === category) !== undefined;
    }
    return false;
  };

  handleOnExpand = category => {
    const curExpandedList = cloneDeep(this.state.expanded);
    if (
      curExpandedList.length > 0 &&
      find(curExpandedList, cat => cat === category) !== undefined
    ) {
      remove(curExpandedList, el => el === category);
    } else {
      curExpandedList.push(category);
    }
    this.setState({
      expanded: curExpandedList,
    });
  };

  handleChangeWeightType = (weightType, weightTypeToTrack) => {
    this.props.handleChangeWeightType(weightType);
    saveTrackingData({
      uid: this.props.loginResponse.data.uid,
      accid: this.props.activeAccountId,
      productNo: this.props.defaultStudy.pn,
      moduleName: this.props.fromPref ? 'Preferences' : this.props.menuName,
      subModule: this.props.fromPref ? this.props.menuName : '',
      action: 'STUDY_SELECTOR_WEIGHT_TYPE',
      detail: { weightType: weightTypeToTrack },
    });
  };

  handleWeightTypes = weightList => {
    if (!isEqual(this.state.selectedWeightType, weightList)) {
      const weightListdata = cloneDeep(weightList);
      if (!isEmpty(weightListdata) && weightListdata.dv === undefined) {
        weightListdata.dv = DV_DEFAULT_VALUE;
      }
      this.setState({ selectedWeightType: weightListdata });
      let moduleName = this.props.fromPref
        ? 'Preferences'
        : this.props.menuName;
      if (moduleName === 'Preferences') {
        this.props.setMethod(weightList, 'weightTypeChange');
      } else {
        moduleName =
          moduleName === 'DictionarySearch' ? CROSSTAB_CONSTANT : moduleName;
        if (moduleName !== CLUSTER_CORRESPONDENCE_MODULE) {
          /**
           * For Cluster and correspondence module both the study and weighttypes are storied in
           * respective project in the correspondenceCluster reducer instead of studyReducer.
           * So this condition makes sure we dont update studyReducer for CLUSTER_CORRESPONDENCE_MODULE
           */
          this.props.studyActions.updateWeightType(moduleName, weightList);
        }
        if (moduleName === CROSSTAB_CONSTANT) {
          if (
            this.props.crosstab &&
            this.props.crosstab.crosstabTableList &&
            this.props.crosstab.crosstabTableList.length &&
            this.props.crosstabSelectedWeight &&
            !isEqual(this.props.crosstabSelectedWeight, weightListdata)
          ) {
            this.props.runReport();
          }
          this.props.getSampleWeightedOfExistingKPIs(weightList);
        } else if (moduleName === QUICKREPORTS_CONSTANT) {
          if (
            this.props.quickReportSelectedWeight &&
            !isEmpty(this.props.quickReportSelectedWeight) &&
            !isEqual(this.props.quickReportSelectedWeight, weightListdata)
          ) {
            this.props.runReport(weightListdata);
          }
          this.props.getSampleWeightedQuickReports(weightList);
        } else if (
          moduleName === MME_MODULE ||
          moduleName === GEO_MAP_MODULE ||
          moduleName === CLUSTER_CORRESPONDENCE_MODULE ||
          moduleName === DATA_ENABLEMENT ||
          moduleName === RLD_TOOL
        ) {
          this.props.handleChangeWeightType(weightListdata);
        }
      }
      saveTrackingData({
        uid: this.props.loginResponse.data.uid,
        accid: this.props.activeAccountId,
        productNo: this.props.defaultStudy.pn,
        moduleName: this.props.fromPref ? 'Preferences' : this.props.menuName,
        subModule: this.props.fromPref ? this.props.menuName : '',
        action: 'STUDY_SELECTOR_WEIGHT_TYPE',
        attributes: { weightType: weightListdata },
      });
    }
  };

  renderWeightTypes = () => {
    const weightTypeLists = this.state.weightTypeLists.map(list => (
      <li
        key={list.wn}
        onClick={() => this.handleWeightTypes(list)}
      >{`${list.wn}`}</li>
    ));
    return weightTypeLists;
  };

  toggleWeightTypeDropdown = () => {
    this.setState(
      prevState => ({
        weightTypeToggle: !prevState.weightTypeToggle,
      }),
      () => {
        if (this.state.weightTypeToggle) {
          document.addEventListener(
            'click',
            this.hideWeightTypeDropdown,
            false
          );
        } else {
          document.removeEventListener(
            'click',
            this.hideWeightTypeDropdown,
            false
          );
        }
      }
    );
  };

  hideWeightTypeDropdown = () => {
    this.toggleWeightTypeDropdown();
  };

  renderStudyName = () => {
    const isAccredited = isStudyAccredited(this.state.selectedStudy.sti);
    if (this.state.selectedStudy && this.state.selectedStudy.sd) {
      const {
        selectedStudy: { sd },
      } = this.state;
      if (sd.includes(' - ')) {
        const sdList = sd.split(' - ');
        return (
          <Fragment>
            <span>{sdList[0]}</span>
            {isAccredited && (
              <img
                src={authorizedIcon}
                className="accredited-img"
                alt="Authorized icon"
              />
            )}
            <span>{` - ${sdList[1]}`}</span>
          </Fragment>
        );
      }
      return (
        <Fragment>
          <span>{this.state.selectedStudy.sd}</span>
          {isAccredited && (
            <img
              src={authorizedIcon}
              className="accredited-img"
              alt="Authorized icon"
            />
          )}
        </Fragment>
      );
    }
    return <span>Loading...</span>;
  };

  renderStudyListLabel = childNode => {
    const isAccredited = isStudyAccredited(childNode.sti);
    if (isAccredited) {
      const sd = childNode.label;
      if (sd.includes(' - ')) {
        const sdList = sd.split(' - ');
        return (
          <Fragment>
            <span
              title={childNode.label}
              data-source={childNode.source}
              onClick={() => this.handleOnCheck(childNode.value)}
              className="study-result-list-label"
            >
              <span>{sdList[0]}</span>
              {isAccredited && (
                <img
                  src={authorizedIcon}
                  className="accredited-img"
                  alt="Authorized icon"
                />
              )}
              <span>{` - ${sdList[1]}`}</span>
            </span>
          </Fragment>
        );
      }
      return (
        <Fragment>
          <span
            title={childNode.label}
            data-source={childNode.source}
            onClick={() => this.handleOnCheck(childNode.value)}
            className="study-result-list-label"
          >
            <span>{childNode.label}</span>
            {isAccredited && (
              <img
                src={authorizedIcon}
                className="accredited-img"
                alt="Authorized icon"
              />
            )}
          </span>
        </Fragment>
      );
    }
    return (
      <Fragment>
        <span
          title={childNode.label}
          data-source={childNode.source}
          onClick={() => this.handleOnCheck(childNode.value)}
          className="study-result-list-label"
        >
          <span>{childNode.label}</span>
        </span>
      </Fragment>
    );
  };

  render() {
    return (
      <div
        className="common-study-selector"
        style={{ width: '100%' }}
        ref={node => (this.studySelElement = node)}
      >
        <Modal
          title={`Run ${this.state.runPopUpModalTitle}`}
          ref={node => (this.runCrosstabModalAfterWeightChange = node)}
          dialogStyles={addAfterRunCrosstabModalStyle}
        >
          <p>You have selected a new weight. Please Run report again. </p>
          <GenericButton
            name="OK"
            btnStyle="button display-block margin-auto"
            onBtnClick={() => this.runCrosstabModalAfterWeightChange.hide()}
          />
        </Modal>
        <Modal
          title=""
          ref={node => (this.modalSetStudy = node)}
          dialogStyles={modalWariningStyle}
        >
          <div
            className="large-12 medium-12 small-12 columns text-center"
            style={{ marginLeft: '-3%' }}
          >
            <div className="columns large-3 medium-3 small-3">
              <img
                className="study-popup-alertIcon"
                id=""
                src={alertIcon}
                alt=""
              />
            </div>
            <div className="columns large-9 medium-9 small-9 study-popup-msg">
              {this.props.alertMsg !== undefined
                ? this.props.alertMsg
                : 'This selection will impact all of the modules'}
            </div>
            <div className="columns large-12 medium-12 small-12">
              <GenericButton
                name="Apply"
                data-test="study-change-button"
                btnStyle="button btn-cncl study-popup-apply"
                onBtnClick={() => {
                  this.modalSetStudy.hide();
                  this.setNewStudy();
                }}
              />
              <GenericButton
                name="Cancel"
                btnStyle="button btn-cncl study-popup-cancel"
                onBtnClick={() => {
                  this.modalSetStudy.hide();
                }}
              />
            </div>
          </div>
        </Modal>
        <span className="study-dropdown-label">{this.props.label}</span>
        {this.props.disableSelection && (
          <div
            className="study-dropdown-div"
            style={{ width: this.props.style && this.props.style.width }}
          >
            <button
              type="button"
              className={`study-dropdown-btn ${
                this.state.dropdownVisible ? 'active' : ''
              }`}
              onClick={this.toggleDropdown}
              data-source={
                this.state.selectedStudy ? this.state.selectedStudy.ss : ''
              }
              disabled={
                (this.state.selectedStudy &&
                  this.state.selectedStudy.sd === undefined) ||
                !this.props.disableSelection
              }
            >
              {this.renderStudyName()}
              {this.props.disableSelection && <span className="arrow-icon" />}
            </button>
            {this.state.dropdownVisible && (
              <div className="study-dropdown-list">
                <div className="study-search-bar">
                  <button
                    type="button"
                    className="button"
                    style={{ cursor: 'initial' }}
                  >
                    <img src={searchIcon} alt="search" />
                  </button>
                  <input
                    type="text"
                    placeholder="Search..."
                    defaultValue={this.state.searchText}
                    onChange={this.handleOnChange}
                    ref={searchBox => {
                      this.searchBox = searchBox;
                    }}
                  />
                  <button
                    type="button"
                    className="button"
                    onClick={this.handleOnClear}
                    style={{
                      display: `${
                        this.state.searchText.length > 1 ? 'block' : 'none'
                      }`,
                    }}
                  >
                    <img src={clearIconBlue} alt="clear" />
                  </button>
                </div>
                {this.state.searchNodes === undefined && (
                  <div className="study-dropdown-msg">
                    No Results Found. Please refine your search.
                  </div>
                )}
                {this.state.searchNodes !== undefined && (
                  <div className="study-result-listing">
                    <ol>
                      {(this.state.searchNodes.length > 0
                        ? this.state.searchNodes
                        : this.state.nodes
                      ).map(node => (
                        <li
                          key={node.value}
                          className={`study-result-list ${
                            this.checkIsExpanded(node.value)
                              ? 'expanded'
                              : 'collapsed'
                          }`}
                        >
                          <span
                            title={node.label}
                            onClick={() => this.handleOnExpand(node.value)}
                            className="study-result-list-title"
                          >
                            {node.label}
                          </span>
                          <ol className="study-result-list-child">
                            {node.children.map(childNode => (
                              <li key={childNode.value}>
                                {this.renderStudyListLabel(childNode)}
                              </li>
                            ))}
                          </ol>
                        </li>
                      ))}
                    </ol>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
        {!this.props.disableSelection && this.state.selectedStudy && (
          <div className="disabled-label">{this.renderStudyName()}</div>
        )}
        <div className="weight-type-wrapper">
          {this.props.showWeightType && !this.props.hideWeightType && (
            <button
              type="button"
              className="weight-type-container"
              onClick={this.toggleWeightTypeDropdown}
            >
              {this.props.disableSelection && (
                <img
                  src={weightingIcon}
                  title="Weighting"
                  className="weight-type-img"
                  alt="Weighting"
                />
              )}
            </button>
          )}
          {this.props.showWeightType && !this.props.hideWeightType && (
            <span className="weight-type-text">WEIGHT</span>
          )}
          {this.props.showWeightType && !this.props.hideWeightType && (
            <span className="weight-vertical-bar">|</span>
          )}
          {this.props.showWeightType && !this.props.hideWeightType && (
            <span className="weight-type-desc">
              {this.state.selectedWeightType.wn}
            </span>
          )}
          {this.state.weightTypeToggle &&
            this.props.showWeightType &&
            !this.props.hideWeightType && (
              <div className="weight-dropdown-component">
                <i className="arrow-up" />
                <div className="weight-type-dropdown">
                  <ul>{this.renderWeightTypes()}</ul>
                </div>
              </div>
            )}
        </div>
        <PortalModal
          isShowing={this.state.showStudyUpdatePopup}
          title=""
          dialogStyles={updatedStudyPopupStyle}
          onCloseClicked={() => this.setState({ showStudyUpdatePopup: false })}
        >
          <H6>UPDATE NOTIFICATION</H6>
          <H6>
            Study Name:{' '}
            {this.state.updatedStudyData && this.state.updatedStudyData.sd}
          </H6>
          {/* <p>This study was updated with changes to data in the following categories/areas:</p>
          <p>Data Correction for USA Today and Wall Street Journal</p> */}
          <p>
            You can always view a detailed summary of these updates in the
            Resources section.
          </p>
          <BtnContainer>
            <GenericButton
              name="SEE THE UPDATES NOW"
              btnStyle="button btn-ok study-update-popup-btn"
              onBtnClick={() => {
                this.context.router.push(`${APP_ROOT_URL}/v2/support`);
                this.setState({ showStudyUpdatePopup: false });
              }}
            />
            <GenericButton
              name="GO TO INSIGHTS"
              btnStyle="button btn-ok study-update-popup-btn-goto"
              onBtnClick={() => {
                this.setState({ showStudyUpdatePopup: false });
                localStorage.removeItem(UPDATE_STUDY_STORAGE_KEY);
              }}
            />
          </BtnContainer>
        </PortalModal>
      </div>
    );
  }
}

CommonStudySelector.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
    }),
  }),
  studies: PropTypes.arrayOf(PropTypes.shape({})),
  defaultStudy: PropTypes.shape({
    wt: PropTypes.number,
    pn: PropTypes.number,
  }),
  activeAccountId: PropTypes.number,
  menuName: PropTypes.string,
  dataOnScreen: PropTypes.func,
  alertMsg: PropTypes.string,
  setMethod: PropTypes.func,
  resetMethod: PropTypes.func,
  latestStudies: PropTypes.arrayOf(
    PropTypes.shape({
      productNo: PropTypes.number,
    })
  ),
  style: PropTypes.shape({
    width: PropTypes.string,
  }),
  showWeightType: PropTypes.bool,
  hideWeightType: PropTypes.bool,
  handleChangeWeightType: PropTypes.func,
  featureID: PropTypes.number.isRequired,
  fromPref: PropTypes.bool,
  studyActions: PropTypes.shape({
    updateWeightType: PropTypes.func,
  }),
  getSampleWeightedOfExistingKPIs: PropTypes.func,
  crosstab: PropTypes.shape({
    crosstabTableList: PropTypes.instanceOf(Array),
  }),
  crosstabSelectedWeight: PropTypes.shape({
    wt: PropTypes.number,
  }),
  datahaulSelectedWeight: PropTypes.shape({
    wt: PropTypes.number,
  }),
  quickReportSelectedWeight: PropTypes.shape({
    wt: PropTypes.number,
  }),
  getSampleWeightedQuickReports: PropTypes.func,
  disableSelection: PropTypes.bool,
  commonStudySelectorRef: PropTypes.func,
  autocode: PropTypes.bool,
};

CommonStudySelector.defaultProps = {
  disableSelection: true,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    crosstab: state.crosstab,
    crosstabSelectedWeight: state.crosstab.crosstabSelectedWeight,
    datahaulSelectedWeight: state.datahaul.datahaulSelectedWeight,
    quickReportSelectedWeight: state.quickReports.quickReportSelectedWeight,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    studyActions: bindActionCreators(studyActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommonStudySelector);
